// extracted by mini-css-extract-plugin
module.exports = {"title":"WhereToGoSectionDescription_title__g_Vb_","descriptionWrapper":"WhereToGoSectionDescription_descriptionWrapper__XDqTC"};